module.exports = __webpack_public_path__ + "img/image-indent-right.2c189cf0.svg";